import PropTypes from 'prop-types'
import React from 'react'
import { withRouter } from 'react-router'
import cx from 'classnames'

import { Gateway } from 'react-gateway'

import Packlists from './Packlists'
import ShellfishPicklists from './Shellfish/Picklists'
import ShellfishSalesLogs from './Shellfish/SalesLogs'
import SmallfishPicklists from './Smallfish/Picklists'

import classes from './Reports.scss'

export const Reports = (props) => {
  const className = cx({
    [classes['container']]: classes['container'],
    [classes['hidden']]: props.hidden && classes['hidden']
  })

  const list = {
    'packlists': Packlists,
    'shellfishpicklists': ShellfishPicklists,
    'shellfishsaleslogs': ShellfishSalesLogs,
    'smallfishpicklists': SmallfishPicklists
  }

  let reports = props.reports || []
  if (!reports.length) reports = Object.keys(list) // all reports

  return <Gateway into='reports'>
    <div className={className}>
      {reports.map((report, i) => {
        let component = typeof report.toLowerCase === 'function' && list[report.toLowerCase()]
        if (!component) return null

        return React.createElement(component, {
          orders: props.orders,
          key: `report-${report}:${i}-${props.orders.length}`
        })
      })}
    </div>
  </Gateway>
}

Reports.propTypes = {
  orders: PropTypes.array.isRequired,
  reports: PropTypes.array,
  hidden: PropTypes.bool,

  location: PropTypes.object
}

Reports.defaultProps = {
  hidden: true,
  reports: []
}

export default withRouter(Reports)



// WEBPACK FOOTER //
// ./src/components/Reports/Reports.js